import { BaseIcon, EthIcon } from 'src/common/assets'
import { ChainName } from './name'

export const WALLET_ICON = {
  [ChainName.ETHEREUM]: EthIcon,
  [ChainName.BASE]: BaseIcon
}
